import Cookies from 'js-cookie';
import pino from 'pino';

import * as constants from '~/constants';

// Standard set of serializers
// https://github.com/pinojs/pino-std-serializers
export const serializers = pino.stdSerializers;

function errorSerializer(err: Error) {
  const json = serializers.err(err);
  const { stack, ...other } = json;
  if (stack) {
    // If stack is available, show the stack first
    console.error(stack);
  }
  // Show the rest of the error object
  return other;
}

/**
 * Any logger from 'debug' level or below is controlled by the
 * 'fairly-debug' cookie.
 *
 * @param flag debug flag to check
 * @example
 *   // if the fairly-debug cookie contains the string:
 *   //   'abc, def-.*'
 *   debugEnabled('abc');  // true
 *   debugEnabled('def');  // true
 *   debugEnabled('ab');  // false
 */
export function debugEnabled(flag: string) {
  const flagCookie = Cookies.get(constants.CLIENT_DEBUG);

  if (!flagCookie) {
    return false;
  }
  const flagList = flagCookie.split(',').map((flg) => {
    const exp = flg.trim();
    const matchExp = new RegExp(`^${exp}$`); // must match whole word
    return !!flag.match(matchExp);
  });
  return flagList.includes(true);
}

/**
 * Logger for browser component
 */
function logger(src: string, opts: pino.LoggerOptions = {}) {
  // Options: https://github.com/pinojs/pino/blob/master/docs/api.md#options
  return pino({
    serializers: {
      err: errorSerializer,
    },
    // If debug is enabled, then the everything above 'trace' is shown
    // Otherwise, only 'info' or above is shown
    level: debugEnabled(src) ? 'debug' : 'info',
    browser: {
      asObject: true,
      // @ts-ignore: for whatever reason, serialize is not documented in
      // pino's type definition
      serialize: [
        // Uncomment to disable default error object serializer
        // '!stdSerializers.err',
        'err',
      ],
    },
    ...opts,
  });
}

const Logger = (src: string, opts?: pino.LoggerOptions) =>
  logger(src, opts).child({ src });
export default Logger;
